module.exports = __webpack_public_path__ + "img/teamio-how-to.137d4517.png";